// extracted by css-extract-rspack-plugin
export default {"description":"_52d1a1b0"};